var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"id":_vm.id,"title":'Deposit Funds',"toggle":_vm.closeAll}},[_c('WalletForm',{attrs:{"miniText":_vm.miniText,"minAmount":_vm.minAmount,"closeModal":_vm.closeAll,"submitForm":_vm.depositFund,"setDefault":_vm.setDefault,"walletId":_vm.walletId,"app":_vm.app,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }